/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon32Regular = forwardRef('DataChartBarsAUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M26 5a1 1 0 0 1 1 1v20a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M20 10a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V10Z" }),
        React.createElement("path", { d: "M6 19a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Z" }),
        React.createElement("path", { d: "M13 15a1 1 0 1 0-2 0v11a1 1 0 1 0 2 0V15Z" })));
});
